import { LinkType } from "src/services/common/common.types";

export enum EntityLinkType {
  PRIMARY = 'primary',
  OTHER = 'other'
}

export const LinkTypeMeta = {
  [LinkType.GITHUB]: {
    icon: 'carbon:logo-github',
    label: 'GitHub',
  },
  [LinkType.LINKEDIN]: {
    icon: 'brandico:linkedin-rect',
    label: 'LinkedIn',
  },
  [LinkType.X]: {
    icon: 'prime:twitter',
    label: 'X',
  },
  [LinkType.FACEBOOK]: {
    icon: 'brandico:facebook-rect',
    label: 'Facebook',
  },
  [LinkType.WEBSITE]: {
    icon: 'solar:global-outline',
    label: 'Website',
  }
};

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}

// Advanced search types

export type SearchOperator =
  | 'match_phrase'
  | 'eq' | 'neq'
  | 'in' | 'nin'
  | 'contains_any' | 'contains_all'
  | 'gt' | 'gte' | 'lt' | 'lte';

// Boolean operators
export type BoolOperator = 'AND' | 'OR' | 'NOT';

// Search atom for a single field search
export interface SearchAtom {
  field: string;
  operator: SearchOperator;
  variant?: string;
  value: any;
}

export type BoolNode = {
  op: BoolOperator;
  children: (BoolNode | SearchAtom)[];
};